import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';

/**
 * `useAsyncSelectOptions` rozwiązuje już wybraną opcję po identyfikatorze tym
 * samym `fetchFn`, co wyszukiwanie. Rozpoznaje się to po klauzuli na polu `id`,
 * bo tylko rozwiązanie po id ją zakłada.
 */
export const isByIdLookup = (
  filter: FilterCriteriaDto,
  idFieldId = 'id',
): boolean => filter.filters.some((clause) => clause.fieldId === idFieldId);

/**
 * Dokłada stałe filtry szybkie do wyszukiwania, ale nie do rozwiązania po
 * identyfikatorze: inaczej pozycja, którą filtr odsiewa, znika z pola przy
 * edycji rekordu, choć została wybrana zanim filtr zaczął ją obejmować.
 */
export const withSearchQuickFilters = (
  filter: FilterCriteriaDto,
  quickFilters: Record<string, boolean>,
  idFieldId = 'id',
): FilterCriteriaDto =>
  isByIdLookup(filter, idFieldId)
    ? filter
    : {
        ...filter,
        quickFilters: { ...filter.quickFilters, ...quickFilters },
      };

/**
 * Wpłatę wolno dopasować także do anulowanej rezerwacji i jej zapisującego, więc select wyłącza domyślne
 * `hideCancelled` przy każdym zapytaniu — również przy rozwiązaniu po id, inaczej wybrana wcześniej
 * anulowana pozycja przestałaby się odczytywać.
 */
export const withCancelledShown = (
  filter: FilterCriteriaDto,
): FilterCriteriaDto => ({
  ...filter,
  quickFilters: { ...filter.quickFilters, hideCancelled: false },
});
